import Phaser from "phaser";
import BootScene     from "./scenes/BootScene.js";
import TitleScene    from "./scenes/TitleScene.js";
import MapScene      from "./scenes/MapScene.js";
import LevelScene    from "./scenes/LevelScene.js";
import BestiaryScene    from "./scenes/BestiaryScene.js";
import LootboxScene     from "./scenes/LootboxScene.js";
import CollectionScene  from "./scenes/CollectionScene.js";
import CreditsScene     from "./scenes/CreditsScene.js";
import LeaderboardScene from "./scenes/LeaderboardScene.js";
import StoreScene       from "./scenes/StoreScene.js";
import OptionsScene     from "./scenes/OptionsScene.js";
import ReplayScene      from "./scenes/ReplayScene.js";
import NameBuilderScene from "./scenes/NameBuilderScene.js";
import { createTweaker } from "./config/tweaker.js";
import { initPillarbox } from "./ui/pillarbox.js";
import { PaymentService } from "./services/PaymentService.js";
import { pingSupabase }   from "./services/SupabaseKeepAlive.js";
import { init as initErrorReporter } from "./services/ErrorReporter.js";

// Handle Stripe redirect callback (?unlock=TOKEN) before the game boots
PaymentService.handleUrlCallback();

// On native platforms (Steam/mobile), auto-restore purchase on boot
import { UnlockManager } from "./services/UnlockManager.js";
const platform = UnlockManager.getPlatform();
if (platform !== 'web' && !PaymentService.isUnlocked()) {
  UnlockManager.restore().catch(() => {}); // silent — don't block boot
}

// Keep both Supabase free-tier projects alive (ping on every game boot)
pingSupabase();

// Error reporting — sends JS crashes to Supabase crash_reports table
initErrorReporter();

// ── Font loading — Kamikaze TTF via FontFace API ──────────────────────────────
// Vite resolves the import to a hashed asset URL at build time.
// The font loads async; it will be ready long before the first combo text appears.
import KamikazeUrl from "./assets/fonts/Kamikaze.ttf";
new FontFace("Kamikaze", `url(${KamikazeUrl})`).load().then(f => document.fonts.add(f));

import OsakaUrl from "./assets/fonts/osaka.ttf";
new FontFace("Osaka", `url(${OsakaUrl})`).load().then(f => document.fonts.add(f));



// Pre-create AudioContext and try to resume immediately.
// Desktop browsers often allow this; mobile will unlock on first tap.
const _audioCtx = new (window.AudioContext || window.webkitAudioContext)();
_audioCtx.resume().catch(() => {});

const config = {
  type: Phaser.AUTO,
  parent: "app",
  backgroundColor: "#0b0f14",
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 540,
    height: 960,
  },
  audio: { context: _audioCtx },
  fps: { target: 60, forceSetTimeOut: true },
  // TitleScene is first → it boots first, then navigates to MapScene on JOGAR
  scene: [BootScene, TitleScene, MapScene, NameBuilderScene, LevelScene, LootboxScene, CollectionScene, BestiaryScene, CreditsScene, LeaderboardScene, StoreScene, OptionsScene, ReplayScene],
};

const game = new Phaser.Game(config);

// Track active scene for error reports
import { setScene } from "./services/ErrorReporter.js";
game.scene.scenes.forEach(s => {
  s.events.on('create', () => setScene(s.constructor.name));
});

// Pillarbox background — fills desktop side-bars with themed art
initPillarbox(game);

// Painel de tweaking — desactivado; descomentar para usar em DEV
// createTweaker(game);
